export const apiConfig = {
  LISTING: '/listings/listed/',
  PROPERTIES: '/listings/properties',
  SEARCH: '/listings/listed',
  NEWSLETTER: '/newsletter/subscribe',
};
